<template>
    <el-container>
        <el-aside width="200px" style="background-color: #304156;">
            <div style="height: 60px" class="cl padding text-center">
<!--                <img src="/admin/images/logo.png" height="40" class="z"/>-->
<!--                <div class="z light margin-left text-center">-->
                    <img src="/images/logo.png" height="36"/>
<!--                    <div class="f-b f-lq">LOGO</div>-->
<!--                    <div></div>-->
<!--                </div>-->
            </div>
            <!--        <m-side-menu :side-collapse="showSideMenu"/>-->
            <m-side-menu :side-collapse="showSideMenu" class="el-menu-vertical-demo" />
        </el-aside>
        <el-container>
            <el-header class="top-nav" style="line-height:60px;">
                <div class="cl">
                    <div class="z">
            <span class="nav-item" @click="toggleSide"
            ><i class="el-icon-s-fold f20" style="vertical-align: middle;"
            /></span>
                    </div>
                    <div class="z">
                        <m-breadcrumb />
                    </div>
                    <div class="y">
                        <span class="nav-item">{{ $user.getUserName() }}</span>
                        <a @click="$router.push({path:'/changePass'})" class="nav-item">修改密码</a>
                        <span class="nav-item" @click="quit()">退出</span>
                    </div>
                </div>
            </el-header>
            <router-view :key="$route.fullPath"/>
        </el-container>
    </el-container>
</template>

<script>
export default {
    name: "Home",
    data() {
        return {
            showSideMenu: true
        };
    },
    created() {
        document.querySelector('body').style.backgroundImage = '';
    },
    methods: {
        toggleSide() {
            this.showSideMenu = !this.showSideMenu;
        },
        quit() {
            this.$utils.sessionClear();
            this.$router.replace({ path: "/login" });
        }
    }
};
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
    min-width: 200px;
    min-height: 400px;
}
</style>
